import { gql } from '@apollo/client';

export const CATEGORY_QUERY = gql`
    query category($categoryID: UUID!) {
        category(categoryID: $categoryID) {
            node {
                name
                description
                sortOrder
                courseIds
                curriculumIds
                brand {
                    id
                    name
                    slug
                    segmentId
                }
                locales {
                    code
                    name
                    description
                }
                segmentIds
                learningProfileIds
                employeeLocaleIds
                localeIds
                companyRelationshipIds
                brandIds
                productIds
            }
        }
    }
`;
